import { useEffect, useRef } from 'react'
import { SelectInput } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'
import { getPrimaryLocaleForCountry } from './localeUtils'


interface LocaleAutoFillProps {
  disabled?: boolean
  locales: any[]
}

const LocaleAutoFill = ({ disabled, locales }: LocaleAutoFillProps) => {
  const form = useForm()
  const { values } = useFormState({ subscription: { values: true } })
  const prevCountryRef = useRef(values.countries_include)

  useEffect(() => {
    const currentCountry = values.countries_include
    if (
      currentCountry &&
      typeof currentCountry === 'string' &&
      currentCountry !== prevCountryRef.current
    ) {
      const trimmed = currentCountry.trim().toUpperCase()
      if (trimmed.length === 2 && /^[A-Z]{2}$/.test(trimmed)) {
        const primaryLocale = getPrimaryLocaleForCountry(trimmed)
        if (primaryLocale) {
          form.change('locale', primaryLocale)
        }
      }
    }
    prevCountryRef.current = currentCountry
  }, [values.countries_include, form])

  return (
    <SelectInput
      choices={locales}
      label={'Language'}
      disabled={disabled}
      fullWidth={true}
      name="locale"
      source="locale"
    />
  )
}

export default LocaleAutoFill

